module.exports = __webpack_public_path__ + "img/2na1.0f4b73c6.svg";